export function buildOciBaseUrl(region: string): string {
  return `https://inference.generativeai.${region.trim().toLowerCase()}.oci.oraclecloud.com/20231130/actions/v1`;
}

const REGION_PATTERN =
  /inference\.generativeai\.([a-z0-9-]+)\.oci\.oraclecloud\.com/i;

export function regionFromBaseUrl(baseUrl: string | null | undefined): string {
  const match = baseUrl?.match(REGION_PATTERN);
  return match ? match[1]!.toLowerCase() : "";
}
